export default __webpack_public_path__ + "static/media/service-thumb-concrete-patio.dcc7ad5b.jpg";